// Generation du calendrier d'une nouvelle saison : jours feries francais et
// reprise des periodes de fermeture de la saison precedente.
import { iso, parseIso } from './planning'

// Ajoute n jours a une date 'AAAA-MM-JJ' (calcul en UTC pour eviter tout decalage horaire)
export function ajouterJours(s, n) {
  const { annee, mois, jour } = parseIso(s)
  const d = new Date(Date.UTC(annee, mois - 1, jour + n))
  return iso(d.getUTCFullYear(), d.getUTCMonth() + 1, d.getUTCDate())
}

// Dimanche de Paques (algorithme de Meeus/Jones/Butcher)
export function paques(annee) {
  const a = annee % 19
  const b = Math.floor(annee / 100)
  const c = annee % 100
  const d = Math.floor(b / 4)
  const e = b % 4
  const f = Math.floor((b + 8) / 25)
  const g = Math.floor((b - f + 1) / 3)
  const h = (19 * a + b - d - g + 15) % 30
  const i = Math.floor(c / 4)
  const k = c % 4
  const l = (32 + 2 * e + 2 * i - h - k) % 7
  const m = Math.floor((a + 11 * h + 22 * l) / 451)
  const mois = Math.floor((h + l - 7 * m + 114) / 31)
  const jour = ((h + l - 7 * m + 114) % 31) + 1
  return iso(annee, mois, jour)
}

// Jours feries legaux d'une annee : { 'AAAA-MM-JJ': 'Nom' }
export function joursFeries(annee) {
  const p = paques(annee)
  return {
    [iso(annee, 1, 1)]: "Jour de l'An",
    [ajouterJours(p, 1)]: 'Lundi de Pâques',
    [iso(annee, 5, 1)]: 'Fête du Travail',
    [iso(annee, 5, 8)]: 'Victoire 1945',
    [ajouterJours(p, 39)]: 'Ascension',
    [ajouterJours(p, 50)]: 'Lundi de Pentecôte',
    [iso(annee, 7, 14)]: 'Fête nationale',
    [iso(annee, 8, 15)]: 'Assomption',
    [iso(annee, 11, 1)]: 'Toussaint',
    [iso(annee, 11, 11)]: 'Armistice 1918',
    [iso(annee, 12, 25)]: 'Noël',
  }
}

// Liste de dates de debut a fin inclus
export function datesEntre(debut, fin) {
  const res = []
  let d = debut
  while (d <= fin) {
    res.push(d)
    d = ajouterJours(d, 1)
  }
  return res
}

// Periodes de fermeture de la saison precedente : au moins 3 jours consecutifs sans
// accueil ni supervision (vacances). Les fermetures isolees (feries, jours ponctuels)
// ne sont pas reprises : elles ne tombent pas aux memes dates d'une annee a l'autre.
// Retour : Map 'MM-JJ' -> libelle (ou null)
export function fermeturesAReprendre(joursPrec, minJours = 3) {
  const tries = [...joursPrec].sort((x, y) => (x.date < y.date ? -1 : 1))
  const reprises = new Map()
  let serie = []
  const vider = () => {
    if (serie.length >= minJours) {
      for (const j of serie) reprises.set(j.date.slice(5), j.libelle || null)
    }
    serie = []
  }
  for (const j of tries) {
    const ferme = !j.accueil_ouvert && !j.supervision_ouverte
    const suite = serie.length > 0 && ajouterJours(serie[serie.length - 1].date, 1) === j.date
    if (ferme && (serie.length === 0 || suite)) serie.push(j)
    else {
      vider()
      if (ferme) serie.push(j)
    }
  }
  vider()
  return reprises
}

// Genere les lignes jours_planning d'une saison.
// Par defaut : accueil et supervision ouverts, hydro fermee (ouverte au cas par cas),
// jours feries fermes (a rouvrir dans le calendrier si besoin).
export function genererJours(debut, fin, reprises) {
  const feries = {}
  for (let a = parseIso(debut).annee; a <= parseIso(fin).annee; a++) Object.assign(feries, joursFeries(a))
  return datesEntre(debut, fin).map(date => {
    const nomFerie = feries[date]
    const repris = reprises ? reprises.has(date.slice(5)) : false
    const ferme = !!nomFerie || repris
    let libelle = null
    if (nomFerie) libelle = `Jour férié : ${nomFerie}`
    else if (repris) libelle = reprises.get(date.slice(5))
    return {
      date,
      supervision_ouverte: !ferme,
      accueil_ouvert: !ferme,
      hydro_ouvert: false,
      ferie: !!nomFerie,
      cours_shp: false,
      accueil_majore: false,
      libelle,
    }
  })
}

// Regroupe les jours fermes consecutifs (hors feries) en periodes { debut, fin, libelle }
export function periodesFermees(jours) {
  const res = []
  let cur = null
  for (const j of jours) {
    const ferme = !j.accueil_ouvert && !j.supervision_ouverte && !j.ferie
    if (ferme && cur && ajouterJours(cur.fin, 1) === j.date) cur.fin = j.date
    else {
      if (cur) res.push(cur)
      cur = ferme ? { debut: j.date, fin: j.date, libelle: j.libelle } : null
    }
  }
  if (cur) res.push(cur)
  return res
}
